import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchClientUsers = createAsyncThunk(
  "clientUsers/fetchClientUsers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/users${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setClientUsersAmount(response.headers["x-total-count"])
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching ClientUsers list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreClientUsers = createAsyncThunk(
  "clientusers/fetchMoreClientUsers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/users${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setClientUsersAmount(response.headers["x-total-count"])
      );

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreClientUsers(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const clientUsersSlice = createSlice({
  name: "clientUsers",
  initialState: {
    clientUsersList: [],
    loading: "idle",
    error: "",
    clientUsersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setClientUsersAmount: (state, action) => {
      state.clientUsersAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientUsers.pending, (state) => {
      state.clientUsersList = [];

      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClientUsers.fulfilled, (state, { payload }) => {
      state.clientUsersList = payload;

      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchClientUsers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreClientUsers.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientUsersList = state.clientUsersList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreClientUsers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientUsersList = state.clientUsersList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setClientUsersAmount } = clientUsersSlice.actions;

export const selectClientUsers = createSelector(
  (state) => ({
    clientUsersList: state.clientUsers.clientUsersList,
    loading: state.clientUsers.loading,
    error: state.clientUsers.error,
    clientUsersAmount: state.clientUsers.clientUsersAmount,
    lastQuery: state.clientUsers.lastQuery,
  }),
  (state) => state
);
export default clientUsersSlice.reducer;
